import React, { useState } from 'react';
import { SlideLayout } from './SlideLayout';
import { motion, AnimatePresence } from 'framer-motion';
import { Play, X, User } from 'lucide-react';
const VIDEOS = [{
  id: 1,
  url: 'https://cdn.magicpatterns.com/uploads/rZXAueVGjghv1Dp2RfbjB3/902B_days_in_roofing_b.undefined',
  label: 'Candidate 1'
}, {
  id: 2,
  url: 'https://cdn.magicpatterns.com/uploads/8x6wWe1AUqbi84gYfrLhwy/902B_days_in_roofing.undefined',
  label: 'Candidate 2'
}, {
  id: 3,
  url: 'https://cdn.magicpatterns.com/uploads/3Hm7GxtSnQfJfy8yoq6FEa/roofing_ap.undefined',
  label: 'Candidate 3'
}, {
  id: 4,
  url: 'https://cdn.magicpatterns.com/uploads/56K5ma2pzMCM5YD2q2SUec/solid_app.undefined',
  label: 'Candidate 4'
}, {
  id: 5,
  url: 'https://cdn.magicpatterns.com/uploads/fKn5jPm1nH13KcJgz7piab/stud_app_b.undefined',
  label: 'Candidate 5'
}, {
  id: 6,
  url: 'https://cdn.magicpatterns.com/uploads/kFfoAJfzteRXVZGycwA9fQ/stud_app_c.undefined',
  label: 'Candidate 6'
}, {
  id: 7,
  url: 'https://cdn.magicpatterns.com/uploads/iTEHs8KY8sLA5cGRGr9GtT/stud_app.undefined',
  label: 'Candidate 7'
}, {
  id: 8,
  url: 'https://cdn.magicpatterns.com/uploads/uKAmbcNV3w6EJAx6ZBUQAi/window_hire_b.undefined',
  label: 'Candidate 8'
}, {
  id: 9,
  url: 'https://cdn.magicpatterns.com/uploads/5nFM7bcC81xjUQMEevUtC6/window_hire_c.undefined',
  label: 'Candidate 9'
}, {
  id: 10,
  url: 'https://cdn.magicpatterns.com/uploads/12CnSLkVG1BDsiRspZcFwV/window_hire.undefined',
  label: 'Candidate 10'
}];
export function Slide4_SystemVisual() {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  return <SlideLayout className="!max-w-none !px-[150px] relative" data-id="element-106">
      {/* Video Buttons - Far Left */}
      <div className="absolute left-6 top-1/2 -translate-y-1/2 flex flex-col space-y-3 z-20 max-h-[80vh] overflow-y-auto py-2 pr-2 scrollbar-hide" data-id="element-107">
        {VIDEOS.map((video, idx) => <motion.button key={video.id} onClick={() => setSelectedVideo(video.url)} className="group relative flex items-center justify-center w-10 h-10 rounded-full bg-slate-800/80 border border-slate-700 hover:bg-emerald-500 hover:border-emerald-400 hover:scale-110 transition-all duration-300 shadow-lg backdrop-blur-sm shrink-0" initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.5 + idx * 0.05
      }} whileHover={{
        scale: 1.1
      }} whileTap={{
        scale: 0.95
      }} data-id="element-108">
            <User className="w-4 h-4 text-slate-300 group-hover:text-white transition-colors" data-id="element-109" />
            <div className="absolute left-full ml-3 px-2 py-1 bg-slate-900/90 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none border border-slate-700 z-30" data-id="element-110">
              View {video.label}
            </div>
            <div className="absolute inset-0 rounded-full bg-emerald-500/20 animate-ping opacity-0 group-hover:opacity-100" data-id="element-111" />
          </motion.button>)}
      </div>

      <div className="flex flex-col h-full justify-center space-y-3" data-id="element-112">
        <motion.div className="text-center space-y-1" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-113">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-white" data-id="element-114">
            The Complete System Architecture
          </h2>
          <p className="text-sm md:text-base text-slate-400" data-id="element-115">
            Visual breakdown of how every stage connects
          </p>
        </motion.div>

        <motion.div className="w-full bg-slate-900/30 rounded-xl border border-slate-800 p-2 shadow-2xl overflow-hidden" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-116">
          <iframe style={{
          border: '1px solid rgba(0, 0, 0, 0.1)'
        }} width="100%" height="100%" className="rounded-lg h-[70vh]" src="https://embed.figma.com/board/VXiMkf6fYlJy2cjipBFyEw/The-HIRE-Advantage?node-id=0-1&embed-host=share" allowFullScreen data-id="element-117" />
        </motion.div>
      </div>

      {/* Video Modal */}
      <AnimatePresence data-id="element-118">
        {selectedVideo && <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setSelectedVideo(null)} data-id="element-119">
            <motion.div className="relative w-full max-w-4xl bg-slate-900 rounded-2xl overflow-hidden border border-slate-700 shadow-2xl" initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} onClick={e => e.stopPropagation()} data-id="element-120">
              <button onClick={() => setSelectedVideo(null)} className="absolute top-4 right-4 z-10 p-2 bg-black/50 hover:bg-black/70 rounded-full text-white transition-colors" data-id="element-121">
                <X size={24} data-id="element-122" />
              </button>
              <div className="aspect-video w-full" data-id="element-123">
                <video src={selectedVideo} className="w-full h-full object-contain bg-black" controls autoPlay data-id="element-124" />
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </SlideLayout>;
}